<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M9.5,4C9.370000000000001,4,9.26,4.05,9.17,4.13C9.17,4.13,9.17,4.13,9.17,4.13C9.17,4.13,5.17,7.63,5.17,7.63C5.17,7.63,5.17,7.63,5.17,7.63C5.07,7.720000000000001,5,7.85,5,8C5,8.15,5.07,8.280000000000001,5.17,8.370000000000001C5.17,8.370000000000001,5.17,8.370000000000001,5.17,8.370000000000001C5.17,8.370000000000001,9.17,11.870000000000001,9.17,11.870000000000001C9.17,11.870000000000001,9.17,11.870000000000001,9.17,11.870000000000001C9.26,11.95,9.370000000000001,12,9.5,12C9.780000000000001,12,10,11.780000000000001,10,11.5C10,11.5,10,4.5,10,4.5C10,4.22,9.780000000000001,4,9.5,4C9.5,4,9.5,4,9.5,4Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'CaretLeft',
} as DefineComponent
</script>
